import { useSuspenseQuery } from "@tanstack/react-query";
import type { PartialDeep } from "type-fest";
import type { SearchDataModel } from "@searchui-searchforms/shared/canonicalizer";
import { normalizeDataModel, normalizedDataModelQueryKey } from "./normalizeDataModel";

export const useNormalizedDataModel = (dataModel: PartialDeep<SearchDataModel>) => {
    const { data } = useSuspenseQuery({
        queryKey: normalizedDataModelQueryKey(dataModel),
        queryFn: () => normalizeDataModel(dataModel),
    });
    return data;
};
